import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

import YmapPlugin from 'vue-yandex-maps';

// you may define your apiKey, lang and version or skip this.
// @todo Перенести API-ключ в конфиг
const options = {
  apiKey: '5dac2409-4f28-491e-8e40-a2a9cc9437d0', // '' by default
  lang: 'ru_RU', // 'ru_RU' by default
  version: '2.1', // '2.1' by default
};
Vue.use(YmapPlugin, options);

new Vue({
  render: h => h(App),
}).$mount('#app');